<template>
  <div>
    <vue-tags-input
      ref="tags-input"
      v-model="tag"
      width="1000"
      :tags="tags"
      :placeholder="tags.length ? '' : 'شماره اضافه کنید'"
      class="ltr"
      @before-adding-tag="handleAdd"
      @tags-changed="handleChange"
    />
  </div>
</template>

<script>
import VueTagsInput from '@johmun/vue-tags-input'

export default {
  name: 'UsersNumberInput',
  components: {
    VueTagsInput
  },
  props: {
    value: { type: [Array], default: () => [] }
  },
  data() {
    return {
      tag: '',
      tags: []
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (val) {
          let tags = []
          tags = this.value.map(item => {
            return {
              text: item,
              tiClasses: ['ti-valid']
            }
          })
          this.tags = tags
        } else return []
      }
    }
  },
  methods: {
    handleChange(newTags) {
      this.tags = newTags
      let data = this.tags.map(item => item.text)
      this.$emit('input', data)
    },
    handleAdd({ addTag, tag }) {
      // Validate tag and tags max
      let tags = this.tags.map(item => item.text)
      tags = tags.map(item => item.noZero())
      let input = tag.text.toEnglish().noZero()
      let isValid = /^[0-9]*$/.test(input)
      if (!isValid) {
        this.$message.error('این شماره معتبر نیست')
      } else if (tags.includes(input)) {
        this.$message.error('این شماره تکراری است')
      } else {
        addTag()
      }
    }
  }
}
</script>
<style lang="scss">
.vue-tags-input {
  max-width: 100% !important;
  .ti-input {
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    &:focus {
      outline: none;
      border-color: #787cf6;
    }
    &:hover {
      border-color: #c0c4cc;
    }
  }
  input::placeholder {
    color: #c6c9d1;
    font-size: 14px;
  }
}
</style>
